import { FsDialog } from './fsDialog';
import { FsDialogHeader } from './fsDialogHeader';
import { FsDialogBody } from './fsDialogBody';
import { FsDialogFooter } from './fsDialogFooter';
import { FsButton } from '../button';

/**
 * Confirmation dialog in the FS design language. Options mirror the
 * material-ui-confirm vocabulary the app already uses:
 * title, description, confirmationText, cancellationText,
 * hideCancelButton, allowClose.
 */
export const FsConfirmDialog = ({ state, options = {}, onClose }) => {
	const {
		title = '',
		description = '',
		confirmationText = 'Ok',
		cancellationText = 'Cancel',
		hideCancelButton = false,
		allowClose = true,
	} = options;

	return (
		<FsDialog
			state={state}
			maxWidth="sm"
			width="480px"
			preventOutsideClick={!allowClose}
			testId="fs-confirm-dialog"
			onClose={() => onClose(false)}>
			<FsDialogHeader
				title={title}
				hideCloseBtn={!allowClose}
				onClose={() => onClose(false)}
			/>
			<FsDialogBody>
				{typeof description === 'string' ? (
					<p className="fs-dialog-subtitle !mt-0">{description}</p>
				) : (
					description
				)}
			</FsDialogBody>
			<FsDialogFooter>
				{!hideCancelButton ? (
					<FsButton variant="outline" fullWidth onClick={() => onClose(false)}>
						{cancellationText}
					</FsButton>
				) : null}
				<FsButton variant="green" fullWidth onClick={() => onClose(true)}>
					{confirmationText}
				</FsButton>
			</FsDialogFooter>
		</FsDialog>
	);
};
